
import { Company, User, UserRole } from './types';

const LOGO_URL = "https://i.postimg.cc/mD8V1G1w/eventlog-logo.png";
const PRIMARY_COLOR = "#00a8e0";
const SECONDARY_COLOR = "#222e3d";

export const getManagerWelcomeEmail = (company: Company, manager: User) => {
  const logo = company.logo || LOGO_URL;
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        @media only screen and (max-width: 620px) {
          .container { width: 100% !important; padding: 10px !important; }
          .content { border-radius: 12px !important; }
          .hero-title { font-size: 20px !important; }
          .cta-button { width: 100% !important; box-sizing: border-box !important; display: block !important; }
        }
      </style>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f4f7f9; font-family: 'Inter', Helvetica, Arial, sans-serif;">
      <div class="container" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 40px 0; text-align: center;">
        <table class="content" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: #ffffff; border-radius: 24px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin: 0 auto; text-align: left;">
          <!-- Header -->
          <tr>
            <td align="center" style="padding: 40px 20px; background-color: ${SECONDARY_COLOR};">
              <img src="${logo}" alt="${company.name}" width="180" style="display: block; max-width: 100%; height: auto; margin: 0 auto;" />
            </td>
          </tr>
          
          <!-- Hero Section -->
          <tr>
            <td style="padding: 40px 30px; text-align: center;">
              <h1 class="hero-title" style="margin: 0; font-size: 24px; font-weight: 900; text-transform: uppercase; letter-spacing: -1px; color: ${SECONDARY_COLOR}; line-height: 1.2; text-align: center;">
                Sua Unidade Logística está <span style="color: ${PRIMARY_COLOR};">PRONTA!</span>
              </h1>
              <p style="font-size: 16px; line-height: 1.6; color: #64748b; margin-top: 15px; text-align: center;">
                Olá, <strong>${manager.name}</strong>. Sua instância da <strong>${company.name}</strong> foi provisionada com sucesso no Core Engine do EventLog Pro.
              </p>
            </td>
          </tr>
  
          <!-- Credentials Card -->
          <tr>
            <td style="padding: 0 30px;">
              <div style="background-color: #f8fafc; border: 1px solid #e2e880; border-radius: 16px; padding: 25px;">
                <p style="margin: 0 0 15px 0; font-size: 10px; font-weight: 900; color: #94a3b8; text-transform: uppercase; letter-spacing: 2px; text-align: center;">Credenciais de Acesso</p>
                <table width="100%" border="0" cellpadding="0" cellspacing="0">
                  <tr>
                    <td align="center" style="padding: 10px 0; font-size: 14px; border-bottom: 1px solid #edf2f7; color: ${SECONDARY_COLOR};"><strong>Login:</strong> ${manager.email}</td>
                  </tr>
                  <tr>
                    <td align="center" style="padding: 10px 0; font-size: 14px; color: ${SECONDARY_COLOR};"><strong>Senha:</strong> <span style="color: ${PRIMARY_COLOR}; font-family: monospace;">A senha definida no cadastro</span></td>
                  </tr>
                </table>
              </div>
            </td>
          </tr>
  
          <!-- Plan Info -->
          <tr>
            <td style="padding: 30px 30px; text-align: center;">
              <p style="font-size: 12px; color: #64748b; margin-bottom: 10px; text-align: center;">Você está operando no Plano <strong>${company.plan}</strong>.</p>
              <div style="width: 100%; height: 4px; background-color: #f1f5f9; border-radius: 2px;">
                <div style="width: 100%; height: 100%; background-color: ${PRIMARY_COLOR}; border-radius: 2px;"></div>
              </div>
            </td>
          </tr>
  
          <!-- CTA -->
          <tr>
            <td align="center" style="padding: 20px 30px 60px 30px;">
              <a href="https://eventlogpro.com.br/login" class="cta-button" style="background-color: ${PRIMARY_COLOR}; color: #ffffff; padding: 18px 40px; border-radius: 14px; text-decoration: none; font-weight: 900; font-size: 14px; text-transform: uppercase; letter-spacing: 1px; display: inline-block; box-shadow: 0 10px 20px rgba(0,168,224,0.3);">
                Acessar Torre de Comando
              </a>
            </td>
          </tr>
  
          <!-- Footer -->
          <tr>
            <td align="center" style="padding: 30px; background-color: #f8fafc; border-top: 1px solid #e2e8f0;">
              <p style="margin: 0; font-size: 11px; color: #94a3b8; font-weight: 700; letter-spacing: 1px;">PRODUTO DESENVOLVIDO POR</p>
              <p style="margin: 5px 0 0 0; font-size: 12px; font-weight: 900; color: ${SECONDARY_COLOR}; text-transform: uppercase;">M3 NEXUS SISTEMAS INTELIGENTES</p>
            </td>
          </tr>
        </table>
        <div style="padding: 20px; font-size: 10px; color: #94a3b8;">
          Este é um e-mail automático, por favor não responda.
        </div>
      </div>
    </body>
    </html>
  `;
};

export const getStaffWelcomeEmail = (companyName: string, staff: User, companyLogo?: string) => {
  const isDriver = staff.role === UserRole.MONTAGEM;
  const logo = companyLogo || LOGO_URL;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <style>
        @media only screen and (max-width: 620px) {
          .container { width: 100% !important; padding: 10px !important; }
          .content { border-radius: 12px !important; }
          .hero-title { font-size: 20px !important; }
          .cta-button { width: 100% !important; box-sizing: border-box !important; display: block !important; }
          .app-btn-cell { display: block !important; width: 100% !important; padding: 5px 0 !important; }
        }
      </style>
    </head>
    <body style="margin: 0; padding: 0; background-color: #f4f7f9; font-family: 'Inter', Helvetica, Arial, sans-serif;">
      <div class="container" style="width: 100%; max-width: 600px; margin: 0 auto; padding: 40px 0; text-align: center;">
        <table class="content" align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="max-width: 600px; background-color: #ffffff; border-radius: 24px; overflow: hidden; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin: 0 auto; text-align: left;">
          <!-- Header -->
          <tr>
            <td align="center" style="padding: 30px 20px; border-bottom: 1px solid #f1f5f9;">
              <img src="${logo}" alt="${companyName}" width="140" style="display: block; max-width: 100%; height: auto; margin: 0 auto;" />
            </td>
          </tr>
          
          <!-- Welcome Section -->
          <tr>
            <td style="padding: 40px 30px;">
              <h2 class="hero-title" style="margin: 0; font-size: 22px; font-weight: 900; color: ${SECONDARY_COLOR}; text-transform: uppercase; line-height: 1.2; text-align: center;">
                Seja Bem-vindo à Equipe!
              </h2>
              <p style="font-size: 15px; line-height: 1.6; color: #64748b; margin-top: 15px; text-align: center;">
                Olá, <strong>${staff.name}</strong>. Você foi cadastrado como <strong>${staff.role}</strong> na unidade <strong>${companyName}</strong>.
              </p>
              <p style="font-size: 14px; color: #64748b; margin-top: 10px; text-align: center;">A partir de agora, suas operações logísticas serão gerenciadas pela nossa plataforma.</p>
            </td>
          </tr>
  
          <!-- Actions -->
          <tr>
            <td style="padding: 0 30px 40px 30px;">
              <div style="background-color: #eff6ff; border-radius: 16px; padding: 25px; text-align: center;">
                ${isDriver ? `
                  <p style="margin: 0 0 20px 0; font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase; letter-spacing: 1px;">MOTORISTA: Baixe o App do Montador para receber suas rotas:</p>
                  <table width="100%" border="0" cellpadding="0" cellspacing="0">
                    <tr>
                      <td align="center">
                        <table border="0" cellpadding="0" cellspacing="0">
                          <tr>
                            <td class="app-btn-cell" style="padding: 0 7px;">
                              <a href="#" style="background-color: #000; color: #fff; padding: 12px 25px; border-radius: 10px; text-decoration: none; font-size: 12px; font-weight: 700; display: inline-block;">Google Play</a>
                            </td>
                            <td class="app-btn-cell" style="padding: 0 7px;">
                              <a href="#" style="background-color: #000; color: #fff; padding: 12px 25px; border-radius: 10px; text-decoration: none; font-size: 12px; font-weight: 700; display: inline-block;">App Store</a>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                  </table>
                ` : `
                  <p style="margin: 0 0 20px 0; font-size: 13px; font-weight: 700; color: #1e40af; text-transform: uppercase; letter-spacing: 1px;">Acesse seu painel administrativo:</p>
                  <a href="https://eventlogpro.com.br/login" class="cta-button" style="background-color: ${PRIMARY_COLOR}; color: #fff; padding: 16px 30px; border-radius: 12px; text-decoration: none; font-size: 13px; font-weight: 900; display: inline-block; text-transform: uppercase; letter-spacing: 1px;">ACESSAR SISTEMA</a>
                `}
              </div>
            </td>
          </tr>
  
          <!-- Footer -->
          <tr>
            <td align="center" style="padding: 30px; color: #94a3b8; font-size: 11px; font-weight: 600; background-color: #f8fafc; border-top: 1px solid #f1f5f9;">
              © 2026 EventLog Pro • Sorocaba Cluster
            </td>
          </tr>
        </table>
      </div>
    </body>
    </html>
  `;
};
